import React, { useState, useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../../index.css";
import { Box, Image, Heading, Text, IconButton } from "@chakra-ui/react";
import { ChevronLeftIcon, ChevronRightIcon } from "@chakra-ui/icons";
import Animated from "./AnimatedSection";
import momin from "../../assets/images/momin.jpg";
import hurr from "../../assets/images/hurr.jpg";
import ali from "../../assets/images/ali.jpg";

import zaigham from "../../assets/images/zaigham.jpg";

function Testimoials() {
  const [centerIndex, setCenterIndex] = useState(0);
  const sliderRef = useRef(null);

  const settings = {
    className: "center",
    centerMode: true,
    infinite: true,
    centerPadding: "0%",
    slidesToShow: 3,
    speed: 500,
    autoplay: false,
    autoplaySpeed: 3000,
    beforeChange: (current, next) => setCenterIndex(next),
    arrows: false,
    dots: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          centerPadding: "50px",
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          centerPadding: "50px",
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerMode: false,
          dots: true,
        },
      },
    ],
  };

  const testimonials = [
    { name: "Hurr Murtaza", role: "CEO / Founder", image: hurr },
    { name: "Momin Abdullah", role: "Managing Director / COO", image: momin },
    { name: "Zaigham Abbas", role: "Head of Media", image: zaigham },
    {
      name: "Muhammad Ali Sajjad",
      role: "Chief Marketing Officer / CMO",
      image: ali,
    },
  ];

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      pb={{ base: 6, lg: 0 }}
    >
      <Box w="90%" position="relative">
        {/* Left Arrow */}
        <IconButton
          display={{ base: "none", md: "flex" }}
          icon={<ChevronLeftIcon w={6} h={6} />}
          aria-label="Previous"
          position="absolute"
          left="-10px"
          top="50%"
          transform="translateY(-50%)"
          zIndex="10"
          bg="brand.200"
          color="black"
          _hover={{ bg: "brand.150", color: "white" }}
          borderRadius="full"
          onClick={() => sliderRef.current?.slickPrev()}
        />

        <Slider ref={sliderRef} {...settings}>
          {testimonials.map((testimonial, index) => {
            const isCenter = index === centerIndex;

            return (
              <Box key={index} transition="all 0.3s ease" position="relative">
                <Image
                  objectFit="cover"
                  borderRadius="32px"
                  w="100%"
                  h={{ base: "400px", lg: isCenter ? "480px" : "440px" }}
                  src={testimonial.image}
                  alt={`Testimonial ${index + 1}`}
                />

                {/* Text overlay */}
                <Box
                  position="absolute"
                  bottom="20px"
                  left="50%"
                  transform="translateX(-50%)"
                  textAlign="center"
                  color="white"
                  width="80%"
                  fontWeight="bold"
                  textShadow="2px 2px 4px rgba(0, 0, 0, 0.8)"
                >
                  <Animated>
                    <Heading fontSize="28px">{testimonial.name}</Heading>
                    <Text fontSize="18px">{testimonial.role}</Text>
                  </Animated>
                </Box>
              </Box>
            );
          })}
        </Slider>

        {/* Right Arrow */}
        <IconButton
          icon={<ChevronRightIcon w={6} h={6} />}
          aria-label="Next"
          display={{ base: "none", md: "flex" }}
          position="absolute"
          right="-10px"
          top="50%"
          transform="translateY(-50%)"
          zIndex="10"
          bg="brand.200"
          color="black"
          _hover={{ bg: "brand.150", color: "white" }}
          borderRadius="full"
          onClick={() => sliderRef.current?.slickNext()}
        />
      </Box>
    </Box>
  );
}

export default Testimoials;
